import type { ReactNode } from "react";

type ConfirmImpactDialogProps = {
  open: boolean;
  title: string;
  currentValue: string;
  nextValue: string;
  externalImpact: string;
  auditTrail: string;
  reason: string;
  confirmLabel: string;
  tone?: "default" | "danger";
  busy?: boolean;
  canConfirm?: boolean;
  extraFields?: ReactNode;
  onReasonChange: (value: string) => void;
  onCancel: () => void;
  onConfirm: () => void;
};

export function ConfirmImpactDialog({
  open,
  title,
  currentValue,
  nextValue,
  externalImpact,
  auditTrail,
  reason,
  confirmLabel,
  tone = "default",
  busy,
  canConfirm = true,
  extraFields,
  onReasonChange,
  onCancel,
  onConfirm
}: ConfirmImpactDialogProps) {
  if (!open) return null;
  return (
    <div className="modal-backdrop" role="presentation">
      <section className="impact-dialog" role="dialog" aria-modal="true" aria-labelledby="impact-dialog-title">
        <h2 id="impact-dialog-title">{title}</h2>
        <dl>
          <div>
            <dt>현재 값</dt>
            <dd>{currentValue}</dd>
          </div>
          <div>
            <dt>변경 후</dt>
            <dd>{nextValue}</dd>
          </div>
          <div>
            <dt>외부 영향</dt>
            <dd>{externalImpact}</dd>
          </div>
          <div>
            <dt>감사 로그</dt>
            <dd>{auditTrail}</dd>
          </div>
        </dl>
        <label>
          사유
          <textarea value={reason} onChange={(event) => onReasonChange(event.target.value)} placeholder="예: 입고 확인, 샘플 이동, 출고 확정" />
        </label>
        {extraFields}
        <div className="dialog-actions">
          <button type="button" onClick={onCancel}>취소</button>
          <button type="button" className={tone === "danger" ? "danger" : "primary"} disabled={busy || !reason.trim() || !canConfirm} onClick={onConfirm}>
            {busy ? "처리 중" : confirmLabel}
          </button>
        </div>
      </section>
    </div>
  );
}
